import {$, ID, Resource, TAG, ValidationMaxLength, ValidationRequired} from 'simpli-web-sdk'
import TipoCnpjFuncaoSchema from '@/schema/TipoCnpjFuncao.schema'

export default class TipoCnpjFuncao extends Resource {

    get $schema() {
        return TipoCnpjFuncaoSchema(this)
    }

    get $id() {
        return this.idTipoFuncaoPk
    }

    set $id(val: ID) {
        this.idTipoFuncaoPk = val
    }

    get $tag() {
        return this.descricao
    }

    set $tag(val: TAG) {
        this.descricao = val
    }

    readonly $name: string = 'TipoCnpjFuncao'

    readonly $endpoint: string = '/user/tipo-cnpj-bulklog{/id}'

    idTipoFuncaoPk: ID = 0

    @ValidationRequired()
    @ValidationMaxLength(255)
    descricao: string = ''

    @ValidationRequired()
    ativo: boolean = false

    async getTipoCnpjFuncao(spinner = 'getTipoCnpjFuncao') {
        const fetch = async () => await this.GET(`/user/tipo-cnpj-bulkloga`)
        return await $.await.run(fetch, spinner)
    }
}
